<template>
	<o-card
		class="shared-stat-card"
		:class="{ 'shared-stat-card--pointer': !!to }"
		size="sm"
		@click="to ? setup.router.push(to) : undefined">
		<div class="flex">
			<div class="flex fd-c">
				<div class="shared-stat-card__icon">
					<o-icon :font-icon="icon"/>
				</div>

				<div class="shared-stat-card__count">
					{{ count }}
				</div>

				<div class="shared-stat-card__label">
					{{ label }}
				</div>
			</div>

			<div
				v-if="to"
				class="shared-stat-card__to">
				<o-icon icon="chevron_right"/>
			</div>
		</div>
	</o-card>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedStatCardEmits, SharedStatCardProps } from './SharedStatCardSetup';
import SharedStatCardSetup from './SharedStatCardSetup';
const emits = defineEmits<SharedStatCardEmits>() as SharedStatCardEmits;
const props = withDefaults(defineProps<SharedStatCardProps>(), SharedStatCardSetup.defaultProps);
const setup = new SharedStatCardSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
@import "@/styles/mixins.less";

.shared-stat-card {
	cursor: default;
	flex: 1;

	&--pointer {
		cursor: pointer;
	}

	&__icon {
		--color: v-bind("setup.rgbColor");
		.square(2.5rem);
		.flex-align();

		border-radius: 0.25rem;
		font-size: 1.25rem;
		color: rgb(var(--color));
		background-color: rgba(var(--color), 0.1);
	}

	&__count {
		font-size: 2rem;
		font-weight: bold;
		color: var(--grey-darker);
	}

	&__label {
		font-size: 1rem;
		font-weight: 600;
		color: var(--grey);
	}

	&__to {
		.flex-align();

		margin-left: auto;
		font-size: 1.5rem;
		color: var(--grey-darker);
	}
}
</style>
